// store.js
import { reactive } from "vue";

export const store = reactive({
  nombre: "",
  setNombre(nombre) {
    this.nombre = nombre;
  },
  user: {},
  setUser(user) {
    this.user = user;
  },
  auth: false,
  setAuth(auth) {
    this.auth = auth;
  },
  authAdmin: false,
  setAuthAdmin(auth) {
    this.authAdmin = auth;
  },
  authReady: false,
  setAuthReady(authReady) {
    this.authReady = authReady;
  },
});
